// extracted by mini-css-extract-plugin
export default {"tooltip":"np-z","sharingV2":"op-z","sharingIconsV2":"pp-z","links":"qp-z","link":"rp-z","facebookV2":"sp-z","twitterV2":"tp-z","pinterestV2":"up-z"};